export default __webpack_public_path__ + "static/media/McDo-yellow-logo-01.1b1ec798.png";